module.exports = __webpack_public_path__ + "static/media/pneuma.affc623e.jpg";